import CheckboxInput from 'rc-checkbox';
import { useEffect, useState } from 'react';

interface CheckboxProps {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  htmlLabel?: JSX.Element;
  hasError?: boolean;
  onlyChecked?: boolean;
  disabled?: boolean;
  blicked?: boolean;
}

const Checkbox = ({ label, checked, onChange, className, htmlLabel, ...props }: CheckboxProps) => {
  const [value, setValue] = useState(checked);

  useEffect(() => {
    setValue(checked);
  }, [checked]);

  const onClick = () => {
    if (props.disabled) return;

    const newValue = !value;
    setValue(newValue);

    if (props.onlyChecked && !newValue && checked) {
      setValue(true);
    }

    if (onChange) {
      onChange(!value);
    }
  };

  return (
    <div
      className={
        'checkbox-wrapper ' + (className ? className : '') + (props.hasError ? ' color-danger' : '')
      }
      onClick={onClick}
    >
      <CheckboxInput
        className={'checkbox' + (props.hasError ? ' checkbox-danger' : '')}
        checked={value}
        disabled={props.disabled}
      />
      <span className={'w100p' + (props.blicked && props.hasError ? ' text-blicked-red' : '')}>
        {!!label && <span className="mr-5 text-long">{label}</span>}

        {!!htmlLabel && htmlLabel}
      </span>
    </div>
  );
};
export default Checkbox;
